import { createRouter, createWebHistory } from 'vue-router'
import isAuthenticatedGuard from './auth-guard'
import autoLoginGuard from './auth-guard-login'
import {isFinancePermission, isProyectaPermission} from './permission-guard'

const routes = [

  {
    path: '/',
    name:'menu',
    beforeEnter:[ isAuthenticatedGuard ],
    component: () => import('@/modules/menu/Menu.vue'),
  },
  {
    path: '/finance',
    beforeEnter:[ isFinancePermission ],
    component: () => import('@/modules/finance/layout/financeLayout.vue'),
    children:[
      {
        path: 'dashboardfinance',
        name:'dashboardFinance',
        component: () => import('@/modules/finance/pages/DashboardFinance.vue')
      },
      {
        path: 'transactions',
        name:'transactionsFinance',
        component: () => import('@/modules/finance/pages/TransactionsFinance.vue')
      },
      {
        path: 'visitors',
        name:'visitorsFinance',
        component: () => import('@/modules/finance/pages/VisitorsFinances.vue')
      },
      {
        path: 'reports',
        name:'reportsFinance',
        component: () => import('@/modules/finance/pages/ReportsFinance.vue')
      },
      {
        path: 'catalogs',
        name:'catalogsFinance',
        component: () => import('@/modules/finance/pages/CatalogFinance.vue')
      },
       {
        path: 'usersfinance',
        name:'usersFinance',
        component: () => import('@/modules/finance/pages/UsersFinances.vue')
      },
      { 
        path: '', 
        redirect: 'dashboardfinance'
      },
    ]
  },
  {
    path: '/proyecta',
    beforeEnter:[ isProyectaPermission ],
    component: () => import('@/modules/home/layouts/HomeLayout.vue'),
    children:[
      {
        path: 'dashboard',
        name:'dashboard',
        component: () => import('@/modules/home/pages/DashboardPage.vue')
      },
      {
        path: 'messages',
        name:'messages',
        component: () => import('@/modules/home/pages/MessagesPage.vue')
      },
      {
        path: 'projects',
        name:'projects',
        component: () => import('@/modules/home/pages/ProjectsPage.vue')
      },
      {
        path: 'teams',
        name:'teams',
        component: () => import('@/modules/home/pages/TeamsPage.vue')
      },
      {
        path: 'users',
        name:'users',
        component: () => import('@/modules/home/pages/UsersPage.vue')
      },
      { 
        path: '', 
        redirect: 'dashboard'
      },
    ]
  },
  {
    path: '/login',
    name:'auth',
    beforeEnter:[ autoLoginGuard ],
    component: () => import('@/modules/auth/layouts/AuthLayout.vue'),
    children: [
      {
        path: '',
        name:'login',
        component: () => import('@/modules/auth/pages/LoginPage.vue')
      },
      {
        path: 'forgot',
        name:'forgot',
        component: () => import('@/modules/auth/pages/ForgotPage.vue')
      },
      {
        path: 'reset/:id',
        name:'reset-pass',
        component: () => import('@/modules/auth/pages/ResetPage.vue'),
        props: ( router ) =>{
          const { id } = router.params
          return { id }
        }
      },   
    ]
  },
  {
    path: '/guide',
    name:'guide',
    beforeEnter:[ isAuthenticatedGuard ],
    component: () => import('@/modules/guide/Guide.vue'),
  },
  { 
    path: '/:pathMatch(.*)*', 
    redirect: '/'
  },
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
